module.exports = __webpack_public_path__ + "img/1514552319.f86cd5c2.jpg";